import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { AmountInput } from '@app/lib/inputs/TextInput/AmountInput'
import { useUpdateProceduralFeeFactor } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/hooks/useUpdateProceduralFeeFactor'

import '../../../styles.scss'

export const ClientCountInput = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()
  const { updateProceduralFeeFactor } = useUpdateProceduralFeeFactor()

  return (
    <InputField
      name='ClientCount'
      label={formatMessage({ id: 'CourtCases.Invoicing.Field.ClientCount' })}
      rules={{
        pattern: {
          value: /^[0-9]*$/,
          message: formatMessage({ id: 'CourtCases.Invoicing.Field.Error.ValidValue' })
        }
      }}
      render={({ inputProps }) => {
        return (
          <AmountInput
            inputProps={{
              ...inputProps,
              onChange: (value) => {
                inputProps.onChange(value)
                updateProceduralFeeFactor()
              }
            }}
            className={b('field', { sm: true })}
          />
        )
      }}
    />
  )
}
